var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-container',{staticClass:"zap-magazine zap-magazine__container",attrs:{"tag":"section"}},[_c('div',{staticClass:"zap-magazine__wrapper"},[_c('oz-zap-magazine-post-list',{attrs:{"posts":_vm.posts,"loading":_vm.loading,"blog-content":_vm.blogContent}}),_c('oz-ads',{staticClass:"zap-magazine__ads",attrs:{"track-id":"homeAdNearBottom","gutter":{
        top: { sm: 'normal' },
        bottom: { sm: 'normal' },
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }